import React from 'react';
import { callMultiple } from '../../utils';
import { Button } from '../Button';
import { Icon } from '../Icon';
import { useHeaderCardContext } from './HeaderCardContext';
import VisibilityOn from '@mollie/ui-assets/icons/utilitarian/VisibilityOn';
import VisibilityOff from '@mollie/ui-assets/icons/utilitarian/VisibilityOff';
export function HeaderButtonObfuscated(props) {
    const { onClick } = props;
    const { obfuscated, setObfuscated } = useHeaderCardContext();
    return (React.createElement(Button, { variant: "icon", onClick: callMultiple(onClick, () => {
            setObfuscated((obfuscated) => !obfuscated);
        }), size: "small" },
        React.createElement(Icon, { src: obfuscated ? VisibilityOn : VisibilityOff })));
}
HeaderButtonObfuscated.displayName = 'Header.ButtonObfuscated';
//# sourceMappingURL=HeaderButtonObfuscated.js.map